export { default } from './SWProductCard';
